import * as tslib_1 from "tslib";
import { Subscription, forkJoin } from 'rxjs';
import { OnInit, OnDestroy } from '@angular/core';
import { TokenService } from '../token/token.service';
import { Router } from '@angular/router';
import { ApplicationService } from '../application/application.service';
import { AcquisitionChannelData, AcquisitionSource, MerchantConfig } from '../application/application';
import { FooterService, Footer } from '../common/footer/footer.service';
import { LoaderService, Loader } from '../common/loader/loader.service';
import { RiskService } from '../risk/risk.service';
import { GiftCardService } from 'app/landing-pages/gift-card/gift-card.service';
import { environment } from '../../environments/environment';
import { AwsTrackingService } from '../common/tracking/aws-tracking.service';
import { AuthGuardService } from '../auth-guard.service';
import { Token, getJourneyTypeFromJourneyVersion } from '../token/token';
import { EventDetails } from 'app/common/tracking/aws-tracker';
import { Title } from '@angular/platform-browser';
export class LoginComponent {
    constructor(tokenService, awsTrackingService, authGuardService, riskService, router, applicationService, footerService, loaderService, giftcardService, titleService) {
        this.tokenService = tokenService;
        this.awsTrackingService = awsTrackingService;
        this.authGuardService = authGuardService;
        this.riskService = riskService;
        this.router = router;
        this.applicationService = applicationService;
        this.footerService = footerService;
        this.loaderService = loaderService;
        this.giftcardService = giftcardService;
        this.titleService = titleService;
        this.activeLoan = null;
        this.pollNextIntervalReference = null;
        this.liveApplicationArray = [];
        this.inProgressApplicationArray = [];
        this.inProgressOrders = [];
        this.s3BucketUrl = environment.s3BucketUrl;
        this.showModal = false;
        this.progressBarValues = [];
        this.checkRadio = 0;
        this.inProgressExtendedApiMerchant = [];
        this.inProgressWithoutApproved = [];
        this.processing = false;
        this.application416 = false;
        this.merchantConfig = new MerchantConfig();
        this.subscription = new Subscription();
        this.isDpAfterRiskApproval = false;
        this.cjmEnabled = false;
        this.isClPaused = false;
        this.isCrossSell = false;
        this.isPerfiosLink = false;
        this.isClIncreaseLink = false;
        this.pollNextModuleAPI = false;
        // public isMoengageUserAttributesAdded = false;
        this.googlePayFlow = null;
        this.titleService.setTitle('ZestMoney');
    }
    ngOnInit() {
        if (location.hash && location.hash.length > 0) {
            const tokenFromUrl = this.getUrlParams(location.hash);
            if (tokenFromUrl && tokenFromUrl.access_token && tokenFromUrl.access_token.length > 0 && tokenFromUrl.token_type === 'Bearer' && tokenFromUrl.expires_in === '3600') {
                this.tokenService.saveToSession(this.getUrlParams(location.hash));
                // this.tokenService.setMixPanelUserId();
            }
            else {
                this.router.navigate(['/authentication']);
            }
        }
        if (!this.tokenService.getToken()) {
            this.router.navigate(['/authentication']);
        }
        else {
            const csProduct = this.tokenService.getCrossSellProduct();
            if (csProduct) {
                this.isCrossSell = true;
            }
            if (this.tokenService.getRedirectToSiFeaturePage()) {
                this.router.navigate(['/features/si']);
            }
            else if (this.tokenService.getRedirectToRepaymentsFeaturePage()) {
                this.router.navigate(['/features/setup']);
            }
            else if (this.tokenService.getBDFromMyAccounts()) {
                this.router.navigate(['features/bank-details-setup']);
            }
            else if (this.tokenService.getKycVerification()) {
                const partnerDetails = this.tokenService.getPartnerRedirectionDetails() ? this.tokenService.getPartnerRedirectionDetails() : false;
                if (partnerDetails && partnerDetails.skipR2Check) {
                    const kycPage = this.tokenService.getKycVerification();
                    this.router.navigate(['features/verification/document' + (kycPage && kycPage.okycOnly ? '/okyc' : '')]);
                }
                else if (partnerDetails && !partnerDetails.skipR2Check) {
                    this.getCustomerRiskStatus();
                }
                else {
                    this.checkRiskStatus();
                }
            }
            else if (this.tokenService.getClIncreaseLinkFlag()) {
                this.checkCliLinkEligiblity();
            }
            else if (csProduct) {
                this.applicationService.getState(null).subscribe(states => {
                    if (states.customer.isPDCompleted) {
                        this.router.navigate([`cs-product/product/${csProduct}`]);
                    }
                    else {
                        this.tokenService.setSkipDashboard(true);
                        this.initializeEverything();
                    }
                });
            }
            else if (this.tokenService.getShowSanctionLetterPage().showSanctionLetter === 'true') {
                this.router.navigate(['/info-page/sanction-letter']);
            }
            else {
                this.initializeEverything();
            }
        }
    }
    initializeEverything() {
        this.awsTrackingService.generateAndUpdateUUID();
        this.isPerfiosLink = this.tokenService.getPerfiosLinkFlag();
        this.isClIncreaseLink = this.tokenService.getClIncreaseLinkFlag();
        this.tokenService.setBdPostKycFlow(false);
        this.tokenService.setJourneyFlowType();
        this.footerService.ShowFooterSource.next(new Footer(false, false, false, false, false, true));
        this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
        this.customerId = this.tokenService.getCustomerId();
        const isSignUp = this.tokenService.getIsSignUp();
        // isSignUp ? this.awsTrackingService.trackMoengageEvent('sign_up_successful') : this.awsTrackingService.trackMoengageEvent('sign_in_successful');
        isSignUp ? this.awsTrackingService.gtmTriggerEvent('sign_up_successful') : this.awsTrackingService.gtmTriggerEvent('sign_in_successful');
        this.buildCustomerAcquisitionData();
        this.giftcardService.getGCMerchantsList().subscribe(merchantSettings => {
            const list = merchantSettings.giftCardPartnerList && merchantSettings.giftCardPartnerList.length > 0 ? merchantSettings.giftCardPartnerList : environment.giftCardPartnerList;
            this.tokenService.setMerchantSettings(list);
        }, error => {
            this.tokenService.setMerchantSettings(environment.giftCardPartnerList);
        });
        let merchantKey = this.tokenService.getReferMerchantKey();
        this.isMerchantKeyAvailable = merchantKey ? true : false;
        let encryptMerchantId = 'true';
        if (!merchantKey) {
            merchantKey = environment.zestMerchantId;
            encryptMerchantId = 'false';
        }
        const UUIDRegexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
        if (UUIDRegexExp.test(merchantKey)) {
            encryptMerchantId = 'false';
        }
        else {
            encryptMerchantId = 'true';
        }
        this.applicationService.getMerchantConfigForUI(merchantKey, encryptMerchantId).subscribe((config) => {
            this.tokenService.saveMerchantConfig(config);
            // this.awsTrackingService.setMoengageUserProperties('PreEnrolMerchantName', config.merchantName);
            this.merchantConfig = config;
            if (this.tokenService.getReactivationContext()) {
                this.tokenService.setIsSignUp(true);
                const { merchantId, merchantName } = this.merchantConfig;
                this.getJourneyAndProceed(merchantId, merchantName);
            }
            else {
                this.assignLoanToCustomer();
            }
            this.googlePayFlow = navigator.userAgent.includes('GPay');
            if (this.googlePayFlow) {
                this.tokenService.setGooglePayEnableFlag();
            }
        }, error => {
            this.assignLoanToCustomer();
        });
    }
    resetCJMFlow() {
        this.cjmEnabled = false;
        this.tokenService.setCJMFlag(this.cjmEnabled);
        this.assignLoanToCustomer();
    }
    assignLoanToCustomer() {
        const application = this.applicationService.getApplication();
        if (application && application.ApplicationId) {
            // Customer has checked out from merchant with loanApplication
            this.activeLoan = { 'ExternalId': application.ApplicationId, 'Status': 'ApplicationInProgress' };
            this.applicationService.assignApplication().subscribe(response => {
                // Check for affiliate marketing campaign
                this.checkForAffiliateMarketingCampaign();
                // Check previous applications
                this.checkActiveApplications();
            }, error => {
                // Assign loanApplication to customer failed, maybe due to duplicate loan prevention checkpoint
                if (error.status === 416) {
                    this.riskService.getCreditLimit(application.ApplicationId).subscribe(limit => {
                        const rejectStatusCodes = ['ZMRSK204', 'ZMRSK401', 'ZMRSK402', 'ZMRSK403'];
                        if (rejectStatusCodes.indexOf(limit.status_code) > -1) {
                            this.tokenService.saveRiskStatusCode(limit.status_code);
                            if (application.IsVoucherMerchant) {
                                this.router.navigate(['/dashboard/declined']);
                            }
                            else {
                                this.router.navigate(['/info-page/rejected']);
                            }
                            return;
                        }
                        else if (limit.status_code === 'ZMRSK303') {
                            this.application416 = true;
                            const discardedApplication = { 'ExternalId': application.ApplicationId, 'Status': 'ApplicationInProgress' };
                            this.inProgressWithoutApproved.push(discardedApplication);
                            this.applicationService.getActiveApplications().subscribe(applications => {
                                this.separateApplicationsInDifferentBuckets(applications);
                            }, error => {
                                this.tokenService.saveRiskStatusCode(limit.status_code);
                                if (application.IsVoucherMerchant) {
                                    this.router.navigate(['/dashboard/declined']);
                                }
                                else {
                                    this.router.navigate(['/info-page/rejected']);
                                }
                                return;
                            });
                        }
                        else {
                            // console.log('credit limit less than basket amount, stopping the journey for ZMRSK416');
                            this.applicationService.getOrderDetails(this.applicationService.getApplicationId()).subscribe(application => {
                                this.applicationService.saveApplication(application);
                                if (application.IsVoucherMerchant) {
                                    this.router.navigate(['/dashboard/credit-limit-insufficient']);
                                }
                                else {
                                    this.router.navigate(['/info-page/credit-limit-insufficient']);
                                }
                            });
                        }
                    });
                }
                else {
                    const body = error.error;
                    if (error.status !== 500 && body && body.ModelState.duplicateLoanId) {
                        if (application.IsVoucherMerchant) {
                            this.router.navigate(['/dashboard/declined']);
                        }
                        else {
                            this.router.navigate(['/info-page/rejected']);
                        }
                    }
                    else {
                        // If loan application is already assigned to some other customer remove the saved applicAtion and proceed
                        if (body && body.ModelState['request.CustomerId']) {
                            this.activeLoan = null;
                            this.applicationService.removeSavedApplication();
                        }
                        this.checkActiveApplications();
                    }
                }
            });
        }
        else {
            // Customer has logged in without loanApplication, check his previous applications
            this.activeLoan = null;
            this.checkActiveApplications();
        }
    }
    buildCustomerAcquisitionData() {
        this.acquisitionChannelData = new AcquisitionChannelData();
        this.acquisitionChannelData.customerId = this.tokenService.getCustomerId();
        this.acquisitionChannelData.applicationId = this.applicationService.getApplicationId() || null;
        this.acquisitionChannelData.affiliateId = this.tokenService.getAffiliateCampaign() || null;
        this.acquisitionChannelData.acquisitionChannel = this.tokenService.getDocumentReferrer() || null;
        this.acquisitionChannelData.acquisitionSource = AcquisitionSource.Other;
        this.acquisitionChannelData.concurrency = false;
    }
    saveAcquisitionData(activeApplication) {
        const applicationId = activeApplication ? activeApplication.ExternalId : null;
        this.acquisitionChannelData.applicationId = applicationId;
        if (this.applicationService.getApplicationId()) {
            this.acquisitionChannelData.acquisitionSource = AcquisitionSource.Merchant;
        }
        if (this.acquisitionChannelData.affiliateId && this.acquisitionChannelData.affiliateId.length > 0) {
            this.acquisitionChannelData.acquisitionSource = AcquisitionSource.Affiliate;
            if (this.acquisitionChannelData.affiliateId.substring(0, 2).toLowerCase() === 'fb') {
                this.acquisitionChannelData.acquisitionSource = AcquisitionSource.Advertisement;
            }
        }
        if (this.inProgressApplicationArray.length === 2 && activeApplication) {
            this.inProgressApplicationArray.forEach(application => {
                if (application.ExternalId !== applicationId) {
                    // For concurrency, check if activeApplication is old one or new one by comparing Created timestamp
                    // If new application is selected, call api once for newer applicationId, else twice with both applicationId's
                    if (new Date(activeApplication.Created) > new Date(application.Created)) {
                        this.acquisitionChannelData.applicationId = activeApplication.ExternalId;
                        this.applicationService.setApplicationChannel(this.acquisitionChannelData).subscribe();
                    }
                    else {
                        this.acquisitionChannelData.applicationId = application.ExternalId;
                        this.applicationService.setApplicationChannel(this.acquisitionChannelData).subscribe();
                        this.acquisitionChannelData.concurrency = true;
                        this.acquisitionChannelData.applicationId = activeApplication.ExternalId;
                        this.applicationService.setApplicationChannel(this.acquisitionChannelData).subscribe();
                    }
                }
            });
        }
        else {
            this.applicationService.setApplicationChannel(this.acquisitionChannelData).subscribe();
        }
    }
    checkForAffiliateMarketingCampaign() {
        const affiliate = this.tokenService.getAffiliateCampaign();
        if (affiliate) {
            this.applicationService.setAffiliateMarketingCampaign(affiliate).subscribe();
        }
    }
    checkActiveApplications() {
        this.applicationService.getActiveApplications().subscribe(applications => {
            // Got active loan applications, loop through and check for concurrency
            applications.sort((a, b) => {
                const d1 = Date.parse(a.Created);
                const d2 = Date.parse(b.Created);
                if (d1 > d2) {
                    return 1;
                }
                return -1;
            });
            if (!this.isPerfiosLink && !this.isClIncreaseLink) {
                this.separateApplicationsInDifferentBuckets(applications);
            }
            else {
                this.goToPreEnrolRedirections();
            }
        }, error => {
            // No active loan applications, getLastDecision on activeLoan and redirect accordingly
            if (this.applicationService.getApplication()) {
                this.getLastDecision();
                this.saveAcquisitionData(this.applicationService.getApplication());
            }
            else {
                this.saveAcquisitionData(null);
                this.applicationService.getState(null).subscribe(states => {
                    this.applicationStates = states;
                    // this.addMoengageUserAttributes(states);
                    if (this.merchantConfig && this.merchantConfig.extendedMerchant && !this.googlePayFlow) {
                        this.goToPreEnrolRedirections();
                    }
                    else {
                        this.checkForMyAccountsRedirection();
                    }
                });
            }
        });
    }
    checkForMyAccountsRedirection() {
        const preventRedirectForETMoney = this.tokenService.getCustomMerchantConfig();
        const riskStage2Status = this.applicationStates.customer.riskStage2Status;
        if ((riskStage2Status === 'Accepted' || riskStage2Status === 'Approved') &&
            this.applicationStates.customer.customerType !== 'Superprime' &&
            (!(this.merchantConfig && this.merchantConfig.preventMyAccountRedirect)) &&
            !this.isPerfiosLink &&
            !this.isClIncreaseLink) {
            this.riskService.getStatus().subscribe((res) => {
                const statusCode = res.status_code;
                const result = res.result;
                if (statusCode === 'ZMRSK200' && result) {
                    if (preventRedirectForETMoney) {
                        this.goToPreEnrolRedirections();
                    }
                    else {
                        this.applicationService.sendDataToLogger('Redirection to youraccounts from loggedinredirect', {
                            reason: 'risk API gave active CL status',
                            riskData: res
                        }, 'INFO').subscribe(() => {
                            this.redirectToYourAccountUrl();
                        }, error => {
                            this.redirectToYourAccountUrl();
                        });
                    }
                }
                else {
                    this.goToPreEnrolRedirections();
                }
            }, (error) => {
                this.goToPreEnrolRedirections();
            });
        }
        else {
            this.riskService.checkCustomerCreditLimitV2().subscribe((res) => {
                const { status_code: bolt_status_code } = res.bolt_cl;
                const { status_code: zest_status_code } = res.zest_cl;
                if ((bolt_status_code === 'ZMRSK400' ||
                    bolt_status_code === 'ZMRSK200') && (zest_status_code === 'ZMRSK406' || zest_status_code === 'ZMRSK204' || zest_status_code === 'ZMRSK420')) {
                    this.applicationService.sendDataToLogger('Redirection to youraccounts from loggedinredirect', {
                        reason: 'dag manager API gave active CL status',
                        riskResponse: res
                    }, 'INFO').subscribe(() => {
                        this.redirectToYourAccountUrl();
                    }, error => {
                        this.redirectToYourAccountUrl();
                    });
                }
                else {
                    this.goToPreEnrolRedirections();
                }
            }, (error) => {
                this.goToPreEnrolRedirections();
            });
        }
    }
    goToPreEnrolRedirections() {
        let merchantName = 'pre-enrol';
        if (this.merchantConfig && this.merchantConfig.merchantName && this.merchantConfig.merchantName.length > 0) {
            const name = this.merchantConfig.offlineGC ? 'offline-gc' : this.merchantConfig.merchantName.toLowerCase();
            merchantName = name + '-pre-enrol';
        }
        this.checkForKycSkip(merchantName, true);
    }
    getJourneyAndProceed(merchantId, merchantName) {
        let homescreenEnabled;
        if (!merchantId || merchantId === '') {
            this.applicationService.sendDataToLogger('Merchant Id is null before posting to CJM Initiate', {
                merchantConfig: this.merchantConfig
            }).subscribe();
        }
        // Check if journey allowed
        this.applicationService.getFlowType(merchantId).subscribe((flow) => {
            if (flow.isCJMAllowed || (this.tokenService.getPerfiosLinkFlag() || this.tokenService.getClIncreaseLinkFlag())) {
                // Initiate CJM Journey
                this.applicationService.createAndGetCJMJourney(merchantId).subscribe((journey) => {
                    this.tokenService.setJourneyFlowType(getJourneyTypeFromJourneyVersion(journey.journeyVersion));
                    if (journey.isCompleted) {
                        const preEnrollReason = 'Journey is already complete for the user.';
                        if (!this.tokenService.getIsSignUp() && journey.showDashboard) {
                            homescreenEnabled = this.fetchHomescreenData(merchantId, journey.journeyId);
                        }
                        if (homescreenEnabled) {
                            homescreenEnabled.then(homescreenObservable => {
                                homescreenObservable.subscribe(response => {
                                    if (response.isHomeScreenImplemented) {
                                        this.tokenService.setJourney(journey);
                                    }
                                    this.loadPreEnrolRoutes({
                                        merchantName,
                                        homescreenEnabled: response.isHomeScreenImplemented,
                                        reason: preEnrollReason
                                    });
                                }, error => this.loadPreEnrolRoutes({ merchantName, reason: preEnrollReason }));
                            }, error => this.loadPreEnrolRoutes({ merchantName, reason: preEnrollReason }));
                        }
                        else {
                            this.loadPreEnrolRoutes({ merchantName, reason: preEnrollReason });
                        }
                    }
                    else {
                        this.tokenService.setCJMFlag(this.cjmEnabled);
                        this.tokenService.setJourney(journey);
                        // Check if next module belongs to cjm
                        this.pollNextAPI(journey, merchantId, merchantName);
                        this.pollNextIntervalReference = window.setInterval(() => {
                            if (this.pollNextModuleAPI) {
                                this.pollNextAPI(journey, merchantId, merchantName);
                            }
                            else if (this.resetNextAPI === 'apiTriggered') {
                                clearInterval(this.pollNextIntervalReference);
                            }
                            else {
                                clearInterval(this.pollNextIntervalReference);
                            }
                        }, 1000);
                    }
                }, error => {
                    this.router.navigate(['application/error'], { queryParams: { error: error.message } });
                });
            }
            else {
                this.router.navigate(['application/error'], { queryParams: { error: 'PDMS API Failed' } });
            }
        }, (error) => {
            this.router.navigate(['application/error'], { queryParams: { error: 'PDMS API Failed' } });
        });
    }
    fetchHomescreenData(merchantId, journeyId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.applicationService.getHomeScreenModule(merchantId, journeyId);
        });
    }
    pollNextAPI(journey, merchantId, merchantName) {
        this.applicationService.getNextModule(journey.journeyId).subscribe((module) => {
            if (['pan-full-name-unified', 'pan-fetch-consent-unified', 'pan-consent-unified', 'ckyc-pd-preview-unified', 'offline-kyc-unified', 'okyc-pd-preview-unified', 'agreement-bolt', 'bolt-gratification-unified', 'personal-details-unified', 'employment-details-unified', 'offline-kyc-unified-after-r2', 'gratification-r1', 'gratification-r2', 'gratification-final', 'personal-details', 'employment-details', 'bank-statements-verification', 'bank-details', 'selfie-additional-details', 'offline-ekyc', 'digital-kyc', 'mandates', 'standalone-bank-statements-verification', 'supplementary-details', 'kyc-instructions', 'video-kyc-digital-compliance', 'video-kyc-offline-compliance', 'video-kyc', 'bank-statements-verification-cli', 'cli-gratification-success', 'cli-gratification-rejected', 'risk-cli', 'selfie-additional-details-before-bd', 'offline-ekyc-before-bd', 'digital-kyc-before-bd', 'bd-penny-drop', 'selfie-web', 'additional-details-web', 'selfie-unified', 'additional-details-unified', 'personal-details-with-kyc', 'bolt-gratification-idff', 'kyc-with-digio-after-r2', 'kyc-with-digio', 'bank-details-penny-drop-unified', 'gratification-r3', 'gratification-r2-v2', 'gratification-final-v2', 'selfie-unified-before-r2', 'selfie-unified-after-r2', 'cibil-verification'].indexOf(module.name) !== -1) {
                this.pollNextModuleAPI = false;
                this.cjmEnabled = true;
                this.tokenService.setCJMFlag(this.cjmEnabled);
                if (['selfie-additional-details-before-bd', 'offline-ekyc-before-bd', 'digital-kyc-before-bd', 'bd-penny-drop'].indexOf(module.name) !== -1) {
                    this.tokenService.setBdPostKycFlow(true);
                }
                // Skip route load and directly go to dashboard/next route
                if (!this.tokenService.getIsSignUp() && journey.showDashboard) {
                    this.homescreenEnabled = this.fetchHomescreenData(merchantId, journey.journeyId);
                    this.checkHomescreenEligibility(this.homescreenEnabled);
                }
                else {
                    this.goToDashboard();
                }
            }
            else {
                if ((module.executionStrategy === 'Background') && (module.status === 'InProgress')) {
                    this.pollNextModuleAPI = true;
                    // this.pollNextAPI(journey, merchantId, merchantName);
                }
                else {
                    this.pollNextModuleAPI = false;
                    this.resetNextAPI = 'apiTriggered';
                    if (!this.tokenService.getIsSignUp() && journey.showDashboard) {
                        this.homescreenEnabled = this.fetchHomescreenData(merchantId, journey.journeyId);
                        this.checkHomescreenEligibility(this.homescreenEnabled);
                    }
                    else {
                        this.loadPreEnrolRoutes({
                            merchantName,
                            reason: `Polling get next for module: ${module.name} neither was in CJM allowed module list nor was a background module`
                        });
                    }
                }
            }
        }, error => {
            this.pollNextModuleAPI = false;
            this.resetNextAPI = 'apiTriggered';
            this.tokenService.setPerfiosLink(false);
            this.isPerfiosLink = false;
            this.tokenService.setClIncreaseLink(false, '');
            this.isClIncreaseLink = false;
            this.tokenService.setBdPostKycFlow(false);
            this.tokenService.setJourneyFlowType();
            if (!this.tokenService.getIsSignUp() && journey.showDashboard) {
                this.homescreenEnabled = this.fetchHomescreenData(merchantId, journey.journeyId);
                this.checkHomescreenEligibility(this.homescreenEnabled);
            }
            else {
                this.loadPreEnrolRoutes({ merchantName, reason: 'Error while trying to poll getNext for customer' });
            }
        });
    }
    checkHomescreenEligibility(homescreenEnabled) {
        homescreenEnabled.then(homescreenObservable => {
            homescreenObservable.subscribe(response => {
                if (response.isHomeScreenImplemented) {
                    this.goToDashboard(true);
                }
                else {
                    this.goToDashboard();
                }
            }, error => this.goToDashboard());
        }, error => this.goToDashboard());
    }
    goToPreEnrol(merchantName) {
        const mConfig = this.tokenService.getMerchantConfig();
        const merchantId = mConfig ? mConfig.merchantId : '';
        // If it's a cross sell user skip cjm and load pre-enrol route
        if (this.isCrossSell) {
            this.loadPreEnrolRoutes({ merchantName, reason: 'Called from kyc skip and crosssell.' });
        }
        else if (this.tokenService.getIsSignUp()) {
            this.tokenService.setPerfiosLink(false);
            this.isPerfiosLink = false;
            this.tokenService.setClIncreaseLink(false, '');
            this.isClIncreaseLink = false;
            // Start CJM based on Baby A/B
            this.applicationService.getFlowType(merchantId).subscribe((flow) => {
                if (flow.isCJMAllowed) {
                    this.getJourneyAndProceed(merchantId, merchantName);
                }
                else {
                    this.loadPreEnrolRoutes({ merchantName, reason: `CJM is not configured` });
                }
            }, error => {
                this.router.navigate(['application/error'], { queryParams: { error: error.message } });
            });
        }
        else {
            // If it's a returning user check which flow to go based on the flow API
            this.applicationService.getFlowType(merchantId).subscribe((flow) => {
                if (flow.isCJMAllowed) {
                    this.getJourneyAndProceed(merchantId, merchantName);
                }
                else {
                    this.loadPreEnrolRoutes({ merchantName, reason: `Flow type is not CJM, flowName is : preapprove}` });
                }
            }, error => {
                this.router.navigate(['application/error'], { queryParams: { error: error.message } });
            });
        }
    }
    // Load pre-enrol routes and then push to dashboard/next route
    loadPreEnrolRoutes({ merchantName, homescreenEnabled = false, reason }) {
        this.applicationService.sendDataToLogger('Preapprove UI got loaded', {
            merchantName,
            reason
        }, 'INFO').subscribe();
        this.cjmEnabled = false;
        this.tokenService.setCJMFlag(this.cjmEnabled);
        this.applicationService.getMerchantRoutes(merchantName).subscribe(response => {
            this.applicationService.setRouteConfigs(response);
            if (homescreenEnabled) {
                this.cjmEnabled = true;
                this.tokenService.setCJMFlag(this.cjmEnabled);
                this.goToDashboard(true);
            }
            else {
                this.goToDashboard();
            }
        }, error => {
            this.applicationService.getMerchantRoutes('pre-enrol').subscribe(response => {
                this.applicationService.setRouteConfigs(response);
                if (homescreenEnabled) {
                    this.cjmEnabled = true;
                    this.tokenService.setCJMFlag(this.cjmEnabled);
                    this.goToDashboard(true);
                }
                else {
                    this.goToDashboard();
                }
            });
        });
    }
    separateApplicationsInDifferentBuckets(applications) {
        const approvedStatus = ['Approved'];
        // Loop through applications and check if there's atleast 1 active loan and one application in progress, if yes then show popup else call getLastDecision on lastActiveApplication
        applications.forEach(application => {
            if ([4, 5, 6, 7, 9].indexOf(application.Flow) === -1) {
                if (application.Status === 'Approved' && (application.LoanStatus === 'Active' || application.LoanStatus === 'InArrears')) {
                    this.liveApplicationArray.push(application);
                }
                else if (application.Status !== 'Approved' || (application.Status === 'Approved' && application.LoanStatus === null) || (application.Status === 'Approved' && application.LoanStatus === 'Approved')) {
                    this.inProgressApplicationArray.push(application);
                }
                if (approvedStatus.indexOf(application.Status) < 0 || (application.Status === 'Approved' && application.LoanStatus === null)) {
                    this.inProgressWithoutApproved.push(application);
                    if (application.IsExtendedApiMerchant) {
                        this.inProgressExtendedApiMerchant.push(application);
                    }
                }
            }
            else {
                // Checkout(1), PersonalLoan(2), PGCheckout(4), ClRedemption(9)
                if ((application.Flow === 1 || application.Flow === 2 || application.Flow === 4 || application.Flow === 9) && (application.Status !== 'Approved')) {
                    // This is specifically to prevent frauds for UTS Transanctions
                }
                else if (application.Status !== 'Approved') {
                    this.applicationService.changeApplicationStatus('CustomerCancelled', application.ExternalId).subscribe(response => {
                        this.awsTrackingService.gtmTriggerEvent('Application-Customer-Cancelled');
                        const event = new EventDetails('autocancellation_on_log_in', 'event', `flow_type_${application.Flow}`);
                        this.awsTrackingService.sendDataToFunnel(event).subscribe();
                    });
                }
                else {
                    if ([6].indexOf(application.Flow) === -1) {
                        this.liveApplicationArray.push(application);
                    }
                }
            }
        });
        this.checkForFlowOnBasisOfApplications();
    }
    checkForFlowOnBasisOfApplications() {
        this.concurrency = { 'status': false, 'count': false };
        if (this.isMerchantKeyAvailable && this.merchantConfig && this.inProgressWithoutApproved.length >= 1) {
            this.applicationService.getState(null).subscribe(states => {
                this.applicationStates = states;
                // this.addUserAttributes(states);
                // if cl is already completed or at terminal status don't show modal
                if (states.customer.riskStage2Status) {
                    if ((this.merchantConfig.cashCreditEnabled || this.merchantConfig.preventMyAccountRedirect) && states.customer.riskStage2Status !== 'Declined') {
                        this.continue(1);
                    }
                    else {
                        this.tokenService.removeReferMerchantKey();
                        this.isMerchantKeyAvailable = null;
                        this.checkForFlowOnBasisOfApplications();
                    }
                }
                else if (this.merchantConfig.cashCreditEnabled || this.merchantConfig.preventMyAccountRedirect) {
                    this.continue(1);
                }
                else {
                    this.getOrderDetails(this.inProgressWithoutApproved);
                }
            }, error => {
                this.getOrderDetails(this.inProgressWithoutApproved);
            });
        }
        else if (this.inProgressWithoutApproved.length === 2) {
            this.getOrderDetails(this.inProgressWithoutApproved);
            const event = new EventDetails('ViewVisited', 'event', 'triggered');
            const props = {
                View: 'ConcurrentTxnScreen',
                Context: 'SignUp',
                LastAction: 'GenerateVoucher'
            };
            this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, props);
        }
        else if (this.inProgressExtendedApiMerchant.length === 1 && this.inProgressWithoutApproved.length === 1) {
            this.getOrderDetails(this.inProgressExtendedApiMerchant);
        }
        else if (this.liveApplicationArray.length > 0 && this.inProgressApplicationArray.length > 0) {
            this.checkRiskFlow(this.inProgressApplicationArray[this.inProgressApplicationArray.length - 1]);
            this.concurrency = { 'status': true, 'count': false };
        }
        else if (this.inProgressApplicationArray.length > 0) {
            this.checkRiskFlow(this.inProgressApplicationArray[this.inProgressApplicationArray.length - 1]);
        }
        else if (this.liveApplicationArray.length > 0) {
            this.checkRiskFlow(this.liveApplicationArray[this.liveApplicationArray.length - 1]);
        }
        else {
            this.checkRiskFlow(null);
        }
        this.applicationService.saveConcurrency(this.concurrency);
    }
    checkRiskFlow(lastActiveApplication) {
        if (lastActiveApplication) {
            if (lastActiveApplication.Status === 'Approved' && (lastActiveApplication.LoanStatus === 'Active' || lastActiveApplication.LoanStatus === 'InArrears')) {
                if (this.isMerchantKeyAvailable && this.merchantConfig && (this.merchantConfig.cashCreditEnabled || this.merchantConfig.preventMyAccountRedirect)) {
                    this.applicationService.getState(this.applicationService.getApplicationId()).subscribe(states => {
                        this.applicationStates = states;
                        // this.addMoengageUserAttributes(states);
                        const { zestPersonalLoanAllowed, creditLimitExpiryDate } = this.applicationStates.customer;
                        const now = (new Date()).getTime();
                        if (zestPersonalLoanAllowed && creditLimitExpiryDate > now) {
                            if (this.applicationStates.customer.creditLimitActive) {
                                this.applicationService.sendDataToLogger('Redirection to youraccounts from loggedinredirect', {
                                    reason: 'User has active loan + CL active + PL eligible',
                                    lastActiveApplication
                                }, 'INFO').subscribe(() => {
                                    this.redirectToYourAccountUrl();
                                }, error => {
                                    this.redirectToYourAccountUrl();
                                });
                            }
                            else {
                                this.redirectToOnboardingFlow();
                            }
                            this.saveAcquisitionData(lastActiveApplication);
                        }
                        else {
                            this.activeLoan = null;
                            this.applicationService.removeSavedApplication();
                            this.selectActiveLoanAndGetLastDecision(null);
                        }
                    }, error => {
                        this.saveAcquisitionData(lastActiveApplication);
                        this.applicationService.sendDataToLogger('Redirection to youraccounts from loggedinredirect', {
                            reason: 'preapprove API gave error',
                            errorMessage: error ? error.message : 'NA',
                            error: error,
                            lastActiveApplication
                        }, 'INFO').subscribe(() => {
                            this.redirectToYourAccountUrl();
                        }, error => {
                            this.redirectToYourAccountUrl();
                        });
                    });
                }
                else {
                    this.applicationService.getState(null).subscribe(states => {
                        const { zestPersonalLoanAllowed, creditLimitExpiryDate } = states.customer;
                        const now = (new Date()).getTime();
                        if (zestPersonalLoanAllowed && creditLimitExpiryDate > now) {
                            if (!states.customer.creditLimitActive) {
                                this.redirectToOnboardingFlow();
                            }
                            else {
                                this.applicationService.sendDataToLogger('Redirection to youraccounts from loggedinredirect', {
                                    reason: 'MerchantKey or merchantConfig is not available',
                                    lastActiveApplication
                                }, 'INFO').subscribe(() => {
                                    this.saveAcquisitionData(lastActiveApplication);
                                    this.redirectToYourAccountUrl();
                                }, error => {
                                    this.saveAcquisitionData(lastActiveApplication);
                                    this.redirectToYourAccountUrl();
                                });
                            }
                        }
                        else {
                            this.saveAcquisitionData(lastActiveApplication);
                            this.redirectToYourAccountUrl();
                        }
                    });
                }
            }
            else if (lastActiveApplication.Status !== 'Approved' || (lastActiveApplication.Status === 'Approved' && lastActiveApplication.LoanStatus === null) || (lastActiveApplication.Status === 'Approved' && lastActiveApplication.LoanStatus === 'Approved')) {
                if (lastActiveApplication.Flow === 2 || lastActiveApplication.Flow === 3) {
                    // console.log('In personal loan flow if flow = 2 or upgrad if flow = 3');
                    this.isCreditLimitCustomer = false;
                    this.selectActiveLoanAndGetLastDecision(lastActiveApplication);
                }
                else {
                    this.riskService.getCreditLimit(lastActiveApplication.ExternalId).subscribe(limit => {
                        const normalFlowStatusCodes = ['ZMRSK404', 'ZMRSK203', 'ZMRSK401', 'ZMRSK408'];
                        const xpeFlowStatusCodes = ['ZMRSK200', 'ZMRSK201', 'ZMRSK202'];
                        const rejectStatusCodes = ['ZMRSK204', 'ZMRSK403'];
                        if (normalFlowStatusCodes.indexOf(limit.status_code) > -1) {
                            this.isCreditLimitCustomer = false;
                            this.selectActiveLoanAndGetLastDecision(lastActiveApplication);
                        }
                        else if (xpeFlowStatusCodes.indexOf(limit.status_code) > -1) {
                            this.applicationService.saveCreditLimitCust(true, limit.credit_limit);
                            this.selectActiveLoanAndGetLastDecision(lastActiveApplication);
                            this.isCreditLimitCustomer = true;
                        }
                        else if (rejectStatusCodes.indexOf(limit.status_code) > -1) {
                            this.saveAcquisitionData(lastActiveApplication);
                            this.tokenService.saveRiskStatusCode(limit.status_code);
                            if (lastActiveApplication.IsVoucherMerchant) {
                                this.router.navigate(['/dashboard/declined']);
                            }
                            else {
                                this.router.navigate(['/info-page/rejected']);
                            }
                            return;
                        }
                        else {
                            // console.log('dont know where to put this guy, may god help him');
                            this.selectActiveLoanAndGetLastDecision(lastActiveApplication);
                        }
                    });
                }
            }
            else {
                this.selectActiveLoanAndGetLastDecision(null);
            }
        }
        else {
            this.selectActiveLoanAndGetLastDecision(null);
        }
    }
    redirectToOnboardingFlow() {
        const { merchantId, merchantName } = this.merchantConfig;
        this.getJourneyAndProceed(merchantId, merchantName);
    }
    selectActiveLoanAndGetLastDecision(application) {
        // If application.Status !== 'Approved' => will include all ApplicationInProgress
        // If application is in progress or if loan is active, i.e approved and NOT cancelled, timedout ect, then set that as the active loan and call getLastDecision
        if (application) {
            this.saveAcquisitionData(application);
            if (application.Status === 'Approved' && (application.LoanStatus === 'Active' || application.LoanStatus === 'InArrears')) {
                this.applicationService.sendDataToLogger('Redirection to youraccounts from loggedinredirect', {
                    reason: 'latest application is approved and loan generated',
                    application
                }, 'INFO').subscribe();
                this.redirectToYourAccountUrl();
            }
            else if (application.Status !== 'Approved' || (application.Status === 'Approved' && application.LoanStatus === null) || (application.Status === 'Approved' && application.LoanStatus === 'Approved')) {
                this.activeLoan = application;
                this.applicationService.getOrderDetails(this.activeLoan.ExternalId).subscribe(application => {
                    this.applicationService.sendDataToLogger('Get active application', {
                        application
                    }).subscribe();
                    this.applicationService.saveApplication(application);
                    this.getLastDecision();
                });
            }
            else {
                this.checkForKycSkip('pre-enrol', true);
            }
        }
        else {
            this.applicationService.getState(null).subscribe(states => {
                this.applicationStates = states;
                // this.addMoengageUserAttributes(states);
                const { zestPersonalLoanAllowed, creditLimitExpiryDate } = this.applicationStates.customer;
                const now = (new Date()).getTime();
                if (zestPersonalLoanAllowed && creditLimitExpiryDate > now) {
                    if (!this.applicationStates.customer.creditLimitActive) {
                        this.redirectToOnboardingFlow();
                    }
                    else {
                        this.applicationService.sendDataToLogger('Redirection to youraccounts from loggedinredirect', {
                            reason: 'Application not present and CL active + PL eligible'
                        }, 'INFO').subscribe(() => {
                            this.redirectToYourAccountUrl();
                        }, error => {
                            this.redirectToYourAccountUrl();
                        });
                    }
                }
                else if (this.merchantConfig && this.merchantConfig.extendedMerchant) {
                    this.goToPreEnrolRedirections();
                }
                else {
                    this.checkForMyAccountsRedirection();
                }
            });
        }
    }
    checkForKycSkip(merchantName, preEnrol) {
        this.applicationService.getFeatureVersion('KYCVerification').subscribe((KYCVerificationVersion) => {
            this.applicationService.tagFeatureToCustomer('KYCVerification', '2.0').subscribe();
            let data;
            data = { skip: true, route: false };
            this.tokenService.setKycSkip(data);
            if (preEnrol) {
                this.goToPreEnrol(merchantName);
            }
            else {
                this.getMerchantRoute(merchantName);
            }
        }, error => {
            if (preEnrol) {
                this.goToPreEnrol(merchantName);
            }
            else {
                this.getMerchantRoute(merchantName);
            }
        });
    }
    getMerchantRoute(merchantName) {
        this.applicationService.getMerchantRoutes(merchantName, this.isCreditLimitCustomer).subscribe(response => {
            this.applicationService.setRouteConfigs(response);
            this.setActualRedirections();
        }, error => {
            if (this.isDpAfterRiskApproval) {
                merchantName = 'default-dpLater';
            }
            else {
                merchantName = 'default';
            }
            this.applicationService.getMerchantRoutes(merchantName, this.isCreditLimitCustomer).subscribe(response => {
                this.applicationService.setRouteConfigs(response);
                this.setActualRedirections();
            });
        });
    }
    setRedirections() {
        let merchantName;
        this.isDpAfterRiskApproval = this.applicationService.getDpConfig();
        if (this.applicationService.getApplicationId()) {
            this.applicationService.getState(this.applicationService.getApplicationId()).subscribe(states => {
                this.applicationStates = states;
                // this.addMoengageUserAttributes(states);
                if (this.isMerchantKeyAvailable && this.merchantConfig && (this.merchantConfig.cashCreditEnabled || this.merchantConfig.preventMyAccountRedirect)) {
                    const { zestPersonalLoanAllowed, creditLimitExpiryDate } = this.applicationStates.customer;
                    const now = (new Date()).getTime();
                    if ((zestPersonalLoanAllowed && creditLimitExpiryDate > now) && !this.merchantConfig.preventMyAccountRedirect) {
                        if (!this.applicationStates.customer.creditLimitActive) {
                            this.redirectToOnboardingFlow();
                        }
                        else {
                            this.applicationService.sendDataToLogger('Redirection to youraccounts from loggedinredirect', {
                                reason: 'if application exists in session and CL is active'
                            }, 'INFO').subscribe(() => {
                                this.redirectToYourAccountUrl();
                            }, error => {
                                this.redirectToYourAccountUrl();
                            });
                        }
                        return true;
                    }
                    else {
                        merchantName = this.merchantConfig.offlineGC ? 'offline-gc-pre-enrol' : 'pre-enrol';
                        this.isCreditLimitCustomer = false;
                        this.activeLoan = null;
                        this.applicationService.removeSavedApplication();
                    }
                }
                else if (states.loan.IsMandateCollectedOffline) {
                    merchantName = 'offline';
                }
                else {
                    merchantName = this.applicationService.getApplication().MerchantName.toLowerCase();
                }
                if (this.isDpAfterRiskApproval) {
                    merchantName = merchantName + '-dpLater';
                }
                this.checkForKycSkip(merchantName, false);
            }, error => {
                merchantName = this.applicationService.getApplication().MerchantName.toLowerCase();
                this.checkForKycSkip(merchantName, false);
            });
        }
        else {
            merchantName = 'pre-enrol';
            this.checkForKycSkip(merchantName, false);
        }
    }
    setActualRedirections() {
        this.authGuardService.getRoutes().subscribe(response => {
            this.goToDashboard();
        });
    }
    getLastDecision() {
        if (this.activeLoan) {
            this.setRedirections();
        }
        else {
            this.checkForKycSkip('pre-enrol', true);
        }
    }
    getUrlParams(urlString) {
        urlString = urlString.replace('#', '');
        const pairs = urlString.split('&');
        const result = new Token();
        if (urlString !== '') {
            pairs.forEach(function (pair) {
                const pairArr = pair.split('=');
                result[pairArr[0]] = decodeURIComponent(pairArr[1] || '');
                result[pairArr[0]] = decodeURIComponent(pairArr[1] || '');
            });
        }
        return result;
    }
    selectApplication(index) {
        this.checkRadio = 1;
        const mapping = ((index === 1) ? 'Old' : 'New') + 'Application';
        const event = new EventDetails('ViewAction', 'click', 'triggered');
        const props = {
            Action: mapping,
            View: 'ConcurrentTxnScreen'
        };
        this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, props);
        if (this.isMerchantKeyAvailable) {
            this.isExtendedApiMerchant = false;
        }
        else {
            this.isExtendedApiMerchant = this.inProgressWithoutApproved[index].IsExtendedApiMerchant;
        }
    }
    getOrderDetails(inProgressApplications) {
        this.getModalDetails(inProgressApplications[0]);
        if (inProgressApplications.length === 2) {
            const orderDetailsInterval = setInterval(fn => {
                if (this.inProgressOrders.length > 0 && this.progressBarValues.length > 0) {
                    this.getModalDetails(inProgressApplications[1]);
                    clearInterval(orderDetailsInterval);
                }
            }, 100);
        }
        const interval = setInterval(fn => {
            if (Object.keys(inProgressApplications).length === this.inProgressOrders.length) {
                this.showModal = true;
                $('body').css({ 'overflow-y': 'hidden' });
                $('#applicationsInProgress').modal('open');
                this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
                clearInterval(interval);
            }
        }, 100);
    }
    getModalDetails(application) {
        this.applicationService.getOrderDetails(application.ExternalId).subscribe(response => {
            this.inProgressOrders.push(response);
        });
        this.applicationService.getApplicationState(application.ExternalId).subscribe(states => {
            const progress = this.getProgressBarValue(states);
            this.progressBarValues.push(progress);
        });
    }
    getProgressBarValue(states) {
        let progressValue = 10;
        if (states.IsMandateCompleted) {
            progressValue = 100;
        }
        else if ((states.IsRiskAccepted || states.IsRiskRefered) && !states.IsMandateCompleted) {
            progressValue = 90;
        }
        else if (!(states.IsRiskAccepted || states.IsRiskRefered) && states.IsBankAccountDetailsComplete) {
            progressValue = 80;
        }
        else if (states.IsPoiUploaded && !states.IsBankAccountDetailsComplete) {
            progressValue = 75;
        }
        else if (states.IsLoanAgreementAccepted && !states.IsPoiUploaded) {
            progressValue = 70;
        }
        else if (states.ProofOfIncomeMethodSelected > 0 && !states.IsLoanAgreementAccepted) {
            progressValue = 60;
        }
        else if (states.IsDownpaymentComplete && states.ProofOfIncomeMethodSelected == null) {
            progressValue = 50;
        }
        else if (states.IsPreAccepted && !states.IsDownpaymentComplete) {
            progressValue = 40;
        }
        return progressValue;
    }
    continue(i, concurrentScreen = false) {
        i = Number(i);
        this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
        this.processing = true;
        if (concurrentScreen) {
            const event = new EventDetails('PrimaryCTA', 'click', 'triggered');
            const props = {
                Action: 'Continue',
                View: 'ConcurrentTxnScreen'
            };
            this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, props);
        }
        if (this.application416) {
            this.activeLoan = this.inProgressWithoutApproved[1];
            $('body').css({ 'overflow-y': 'auto' });
            if (i === 0) {
                $('#applicationsInProgress').modal('close');
                this.applicationService.saveApplication(this.inProgressOrders[0]);
                this.saveAcquisitionData(this.activeLoan);
                if (this.applicationService.getApplication().IsVoucherMerchant) {
                    this.router.navigate(['/dashboard/credit-limit-insufficient']);
                }
                else {
                    this.router.navigate(['/info-page/credit-limit-insufficient']);
                }
            }
            else {
                this.applicationService.saveApplication(this.inProgressOrders[1]);
                $('#applicationsInProgress').modal('close');
                this.checkRiskFlow(this.activeLoan);
            }
        }
        else if (this.isMerchantKeyAvailable && this.merchantConfig && this.inProgressWithoutApproved.length >= 1) {
            const observables = [];
            this.activeLoan = null;
            if (i === 1) {
                this.applicationService.removeSavedApplication();
                for (let j = 0; j < this.inProgressWithoutApproved.length; j++) {
                    observables.push(this.applicationService.changeApplicationStatus('CustomerCancelled', this.inProgressWithoutApproved[j].ExternalId));
                }
            }
            else {
                this.activeLoan = this.inProgressWithoutApproved[0];
                this.applicationService.saveApplication(this.inProgressOrders[0]);
                if (this.inProgressWithoutApproved.length > 1) {
                    for (let j = 1; j < this.inProgressWithoutApproved.length; j++) {
                        observables.push(this.applicationService.changeApplicationStatus('CustomerCancelled', this.inProgressWithoutApproved[j].ExternalId));
                    }
                }
            }
            if (observables.length > 0) {
                this.cancelMultipleApplications(observables)
                    .subscribe(response => {
                    this.proceedAfterSelectingApplication();
                });
            }
            else {
                this.proceedAfterSelectingApplication();
            }
        }
        else {
            this.activeLoan = this.inProgressWithoutApproved[i];
            const otherIndex = Math.abs(i - 1);
            const cancelLoan = this.inProgressWithoutApproved[otherIndex];
            this.applicationService.saveApplication(this.inProgressOrders[i]);
            this.applicationService.changeApplicationStatus('CustomerCancelled', cancelLoan.ExternalId).subscribe(response => {
                this.proceedAfterSelectingApplication();
            }, error => {
                this.processing = false;
                this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
            });
        }
    }
    cancelMultipleApplications(applicationObservable) {
        return forkJoin(applicationObservable);
    }
    proceedAfterSelectingApplication() {
        $('#applicationsInProgress').modal('close');
        $('body').css({ 'overflow-y': 'auto' });
        this.awsTrackingService.gtmTriggerEvent('Application-Customer-Cancelled');
        if (this.activeLoan && this.activeLoan.IsExtendedApiMerchant) {
            this.saveAcquisitionData(this.activeLoan);
            setTimeout(fn => {
                window.location.href = 'http://www.mi.com/in/';
            }, 500);
        }
        else {
            this.checkRiskFlow(this.activeLoan);
        }
    }
    goBackToExtendedApiMerchant(extendedApiMerchantApplication) {
        this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
        const activeLoan = {
            ExternalId: extendedApiMerchantApplication.ApplicationId,
            Created: extendedApiMerchantApplication.CreatedOn
        };
        this.saveAcquisitionData(activeLoan);
        setTimeout(fn => {
            window.location.href = 'http://www.mi.com/in/';
        }, 500);
    }
    goToZest() {
        this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
        window.location.href = environment.staticWebsiteUrl;
    }
    cancelApplications(applications) {
        this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
        this.activeLoan = null;
        for (let i = 0; i < applications.length; i++) {
            this.applicationService.changeApplicationStatus('CustomerCancelled', applications[i].ExternalId).subscribe(response => {
                this.awsTrackingService.gtmTriggerEvent('Application-Customer-Cancelled');
                if (i === applications.length - 1) {
                    $('#applicationsInProgress').modal('close');
                    this.saveAcquisitionData(this.activeLoan);
                    this.checkRiskFlow(this.activeLoan);
                }
            });
        }
    }
    redirectToYourAccountUrl() {
        const param = this.tokenService.getParamString();
        let url = environment.youraccountUrl + '/dashboard#' + param;
        if (this.tokenService.getReferMerchantKey()) {
            url = url + '&merchantKey=' + encodeURIComponent(this.tokenService.getReferMerchantKey());
        }
        if (this.tokenService.getMerchantCustomerId()) {
            url = url + '&merchantCustomerId=' + this.tokenService.getMerchantCustomerId();
        }
        window.location.href = url;
    }
    // Terminal on loggedinredirect
    goToDashboard(homescreenRedirection = false) {
        const isSignUp = this.tokenService.getIsSignUp();
        const skipDashboard = this.tokenService.getSkipDashboard();
        const isOfflienGCAgent = this.tokenService.getOfflineGcAgent();
        const application = this.applicationService.getApplication();
        const perfiosLink = this.tokenService.getPerfiosLinkFlag();
        const clIncreaseLink = this.tokenService.getClIncreaseLinkFlag();
        if ((this.isClPaused || !isSignUp) && !perfiosLink && !clIncreaseLink && !skipDashboard && !isOfflienGCAgent && (!application || (application && application.IsVoucherMerchant)) && !homescreenRedirection) {
            this.router.navigate(['dashboard']);
        }
        else {
            this.applicationService.goToNextRoute(this.router.url.split('#')[0], homescreenRedirection && !clIncreaseLink);
        }
    }
    ngOnDestroy() {
        clearInterval(this.pollNextIntervalReference);
        this.subscription.unsubscribe();
    }
    checkRiskStatus() {
        const allApplications = [], approvedApplications = [];
        this.applicationService.getActiveApplications().subscribe(applications => {
            applications.forEach(application => {
                if ([4, 5, 6].indexOf(application.Flow) === -1) {
                    if (application.Status === 'Approved') {
                        approvedApplications.push(application);
                    }
                    allApplications.push(application);
                }
            });
            const applicationId = (approvedApplications.length > 0) ? approvedApplications[0].ExternalId : (allApplications.length > 0) ? allApplications[0].ExternalId : null;
            if (applicationId) {
                this.applicationService.getState(allApplications[0].ExternalId).subscribe(response => {
                    // this.addMoengageUserAttributes(response);
                    const riskAccepted = ((response.customer && response.customer.riskStage2Status && (response.customer.riskStage2Status !== 'Declined')) || (response.loan.IsRiskAccepted || response.loan.IsRiskRefered));
                    if (riskAccepted) {
                        const kycPage = this.tokenService.getKycVerification();
                        this.router.navigate(['features/verification/document' + (kycPage && kycPage.okycOnly ? '/okyc' : '')]);
                    }
                    else {
                        this.initializeEverything();
                    }
                }, error => {
                    this.initializeEverything();
                });
            }
            else {
                this.checkCustomerClAssigned();
            }
        }, error => {
            this.checkCustomerClAssigned();
        });
    }
    checkCliLinkEligiblity() {
        // check cl assigned, cl expired case, R2 declined and R2 referred
        this.riskService.checkCustomerCreditLimit().subscribe(clState => {
            const clAssigned = clState && clState.credit_limit && clState.credit_limit.approved_amt ? true : false;
            const clExpired = clState && ['ZMRSK408', 'ZMRSK403', 'ZMRSK404'].indexOf(clState.status_code) > -1;
            this.applicationService.getState(null).subscribe(response => {
                // this.addMoengageUserAttributes(response);
                const riskNotEligible = (response.customer && response.customer.riskStage2Status && (response.customer.riskStage2Status === 'Declined' || response.customer.riskStage2Status === 'Referred'));
                if (riskNotEligible || !clAssigned || clExpired) {
                    this.router.navigate(['info-page/cli-error']);
                }
                else {
                    this.initializeEverything();
                }
            }, error => {
                const event = new EventDetails('cli_link_preapprove_states_error', 'event', 'triggered');
                this.awsTrackingService.sendDataToFunnel(event).subscribe();
                if (!clAssigned || clExpired) {
                    this.router.navigate(['info-page/cli-error']);
                }
                else {
                    this.initializeEverything();
                }
            });
        }, error => {
            const event = new EventDetails('cli_link_risk_error', 'event', 'triggered');
            this.awsTrackingService.sendDataToFunnel(event).subscribe();
            this.initializeEverything();
        });
    }
    getCustomerRiskStatus() {
        this.applicationService.getState(null).subscribe(response => {
            // this.addMoengageUserAttributes(response);
            const riskAccepted = (response.customer && response.customer.riskStage2Status && (response.customer.riskStage2Status !== 'Declined'));
            if (riskAccepted) {
                const kycPage = this.tokenService.getKycVerification();
                this.router.navigate(['features/verification/document' + (kycPage && kycPage.okycOnly ? '/okyc' : '')]);
            }
            else {
                this.initializeEverything();
            }
        }, error => {
            this.initializeEverything();
        });
    }
    checkCustomerClAssigned() {
        this.riskService.checkCustomerCreditLimit().subscribe(clState => {
            const clAssigned = clState && clState.credit_limit && clState.credit_limit.approved_amt;
            if (clAssigned) {
                const kycPage = this.tokenService.getKycVerification();
                this.router.navigate(['features/verification/document' + (kycPage && kycPage.okycOnly ? '/okyc' : '')]);
            }
            else {
                this.initializeEverything();
            }
        }, error => {
            const event = new EventDetails('kyc_link_risk_error', 'event', 'triggered');
            this.awsTrackingService.sendDataToFunnel(event).subscribe();
            this.initializeEverything();
        });
    }
}
